import {AppElement, html} from '../AppElement.js';
import FlashGroupHotelExpandCard from "./FlashGroupHotelExpandCard";
import FlashGroupGroupExpandCard from "./FlashGroupGroupExpandCard";

export default class FlashGroup extends AppElement {
    static get properties() {
        return {
            hotelGroup: { type: Object },
            recordDate: { type: String },
            pickupSetting: { type: Number }
        };
    }

    constructor(props = {}) {
        super();
        this.hotelGroup = props.hotelGroup;
        this.recordDate = props.recordDate || window.infinito.vao.controller.storageHelper.getCurrentDate();
        this.pickupSetting = props.pickupSetting || window.infinito.vao.controller.storageHelper.getPickupOffset();
    }

    renderCards() {
        let cards = [];

        // Group card loads its own BI hotel-group aggregate; hotel rows do not feed it.
        let card = new FlashGroupGroupExpandCard({
            hotelGroup: this.hotelGroup,
            recordDate: this.recordDate,
            pickupSetting: this.pickupSetting
        });

        this.hotelGroup.hotels.forEach(hotel => {
            let hotelCard = new FlashGroupHotelExpandCard({
                hotel,
                recordDate: this.recordDate,
                pickupSetting: this.pickupSetting
            });
            cards.push(hotelCard);
        });

        let ncards = [];
        ncards.push(card);
        for (var i = 0; i < cards.length; i++) {
            ncards.push(cards[i]);
        }

        return ncards;
    }

    render() {
        return html`
        <div class="vao__components--flashGroup">
            <div class="vao__components--flashGroup-cards">
                ${this.renderCards()}
            </div>       
        </div>
        `;
    }
}

window.vao = window.vao || {};
window.vao.components = window.vao.components || {};
window.vao.components.FlashGroup = FlashGroup;
customElements.define('vao-flash-group', FlashGroup);
